"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Upload = _interopRequireDefault(require("./Upload"));

var _default = _Upload.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-upload/lib/index.js
// module id = 1289
// module chunks = 0